import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import LocalePage from "../components/LocalePage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const LocalePageContainer = connect(mapStateToProps, mapDispatchToProps)(LocalePage);

export default LocalePageContainer;


// WEBPACK FOOTER //
// ./src/containers/LocalePageContainer.js